module.exports = __webpack_public_path__ + "img/sc-2-act.5770e722.png";